import splitOnTerm from './SplitOnTerm';
import takeNCharacters from './TakeNCharacters';
import removeTerm from './RemoveTerm';

const rules = [
  splitOnTerm,
  takeNCharacters,
  removeTerm,
];

export default rules;
